/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PlannedAction {

    NEW = 'NEW',

    REPLACE = 'REPLACE',

    RETAIN = 'RETAIN',

    NOT_RELEVANT = 'NOT_RELEVANT',

    NO_SYSTEM = 'NO_SYSTEM'
}

